export enum MonitorRuleStatus {
    Neutral = 0,
    Valid = 1,
    Invalid = 2
}
